<template >
  <div class="container-fluid">
    <router-link class="btn btn-circle torre-red" :to="{ name: 'usersNew' }" title="Dodaj model telefonu">
      <i class="material-icons" >
      add
      </i>
    </router-link>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label>Login</label>
              <input type="text" class="form-control" @keyup="onTextChanged" v-model="form.searchLogin">
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label>Imię</label>
              <input type="text" class="form-control" @keyup="onTextChanged" v-model="form.searchName">
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label>Nazwisko</label>
              <input type="text" class="form-control" @keyup="onTextChanged" v-model="form.searchSurname">
            </div>
          </th>
          <th scope="col" class="align-top">
            <div class="">
              <label >Punkt</label>
            </div>
          </th>
          <th scope="col" class="align-top">
            <div class="text-center">
              <label >Edycja</label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in users" :key="item.id">
          <td>{{ item.login }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.surname }}</td>
          <td>{{ storeLabel(item.store) }}</td>
          <td class="text-center"><router-link :to="{ name: 'usersEdit', params: { id: item.id} }">edytuj</router-link></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import un from 'underscore'
import uns from "underscore.string"

export default {
  name: "Users",
  data: () => ({
    allUsers: [],
    users: [],
    form: {
      searchLogin: "",
      searchName: "",
      searchSurname: ""
    }
  }),
  created: function() {
    const req = axios({
      method: 'get',
      url: appConfig.baseUrl + '/users',
      headers: {
        Authorization: userService.getAuthHeader()
      }
    })
    req.then(res => {
      this.allUsers = un.map(res.data, item => {
        return {
          id: item.id,
          login: item.login,
          name: item.userInfo.userName,
          surname: item.userInfo.userSurname,
          store: item.store
        }
      });
      this.allUsers = un.sortBy(this.allUsers, user => {
        return user.surname.toLowerCase();
      });
      this.users = this.allUsers;
    }).catch(err => {
      console.log(err);
    })
  },
  methods: {
    storeLabel(store) {
      return store.name !== "" ? store.name : "Brak"
    },
    getSurnameMatch: function(input) {
      if (uns.isBlank(this.form.searchSurname))
        return true;
      const lowerSearch = this.form.searchSurname.toLowerCase();
      const lowerInput = input.toLowerCase();
      return uns.include(lowerInput, lowerSearch);
    },
    getNameMatch: function(input) {
      if (uns.isBlank(this.form.searchName))
        return true;
      const lowerSearch = this.form.searchName.toLowerCase();
      const lowerInput = input.toLowerCase();
      return uns.include(lowerInput, lowerSearch);
    },
    getLoginMatch: function(input) {
      if (uns.isBlank(this.form.searchLogin))
        return true;
      const lowerSearch = this.form.searchLogin.toLowerCase();
      const lowerInput = input.toLowerCase();
      return uns.include(lowerInput, lowerSearch);
    },
    reloadContent: function() {
      this.users = un.filter(this.allUsers, user => {
        const loginMatch = this.getLoginMatch(user.login);
        const nameMatch = this.getNameMatch(user.name);
        const surnameMatch = this.getSurnameMatch(user.surname);
        return loginMatch && nameMatch && surnameMatch;
      });
    },
    onTextChanged: un.debounce(function (e) {
      this.reloadContent();
    }, 300),
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue